module.exports = __webpack_public_path__ + "img/list-pattern1.6eb871b.svg";